import {Injector, NgModule} from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import {AddToCompareComponent_Generic} from './add-to-compare';
import { SuccessModalModuleGeneric } from '@signature-it/ngx-catalogue/components/success-modal';
import {createCustomElement} from "@angular/elements";
import {RouterModule} from "@angular/router";
import {MatDialogModule} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        SuccessModalModuleGeneric,
        MatDialogModule,
        MatIconModule
    ],
    declarations: [AddToCompareComponent_Generic],
    exports: [AddToCompareComponent_Generic]
})

export class AddToCompareModule_Generic {
    constructor(private injector: Injector) {
        const AddToCompareComp = createCustomElement(AddToCompareComponent_Generic, {injector});
        !customElements.get('ngx-add-to-compare') && customElements.define('ngx-add-to-compare', AddToCompareComp);
    }
}
